import './chunk-17755bd7.js';
import './chunk-8716473c.js';
import './chunk-5160dcda.js';
import './chunk-1a6eab4a.js';
import './chunk-dc90942e.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-044817e6.js';
import { A as Autocomplete } from './chunk-3dc3564a.js';
export { A as Autocomplete } from './chunk-3dc3564a.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/autocomplete.js
// module id = 224
// module chunks = 0